/**
 * 動画画面種別.
 */

/** 動画. */
export const VIDEO_TYPE = "V";

/** LIVE. */
export const LIVE_TYPE = "L";